import React, { useCallback, useEffect, useState } from "react"
import Button from "./Button"
import webviewActions from "@root/misc/webviewActions"

interface Props {
  url: string,
  title: string,
}

const ShareLinkInWebviewToApp: React.FC<Props> = ({ url, title }) => {
  return <Button primary onClick={() => webviewActions.share(url)} iconPos="end" iconBaseName="iconSocialShare">{title}</Button>
}

export default ShareLinkInWebviewToApp
